export default __webpack_public_path__ + "static/media/Background_00261.16d67eab.png";